import { inBrowser } from "vitepress";
import { ref } from "vue";

const isScreenOpen = ref(false);

export function useNav() {
  function openScreen() {
    isScreenOpen.value = true;
    if (inBrowser) {
      document.body.style.overflow = "hidden";
    }
  }

  function closeScreen() {
    isScreenOpen.value = false;
    if (inBrowser) {
      document.body.style.overflow = "";
    }
  }

  function toggleScreen() {
    if (isScreenOpen.value) {
      closeScreen();
    } else {
      openScreen();
    }
  }

  return {
    isScreenOpen,
    openScreen,
    closeScreen,
    toggleScreen,
  };
}
